import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  { id: "3d5a5402-028a-4265-b6dc-801d23615d80", content: "First order high-pass", options: {} },
  { id: "303f3035-4e6a-4f96-9055-366a2af50220", content: "Second order high-pass", options: {} },
  { id: "82f0a78d-5927-4ac7-a9a8-327488afa59c", content: "First order low-pass", options: {} },
  { id: "928bf022-27a9-4e4b-a689-7c94d6319019", content: "Second order low-pass", options: {} },
  { id: "7a40a3f3-0aee-4be7-a9e4-ed5da176ed64", content: "Second order band-pass", options: {} },
  { id: "ed7ceaa5-4aed-4ea1-a8c1-56f01666bbbc", content: "Second order high-stop", options: {} },
];

export const task: Task = {
  id: "1d0e9a2e-2149-4b1a-bd35-e8bcf4980d68",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: false,
    columns: 2,
    shuffle: true,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["928bf022-27a9-4e4b-a689-7c94d6319019"],
};
